import { useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';
import { useSetAtom } from 'jotai';

import { fetchDownloadableContentsAtom } from './atoms';
import { DLC_MODEL_TYPES, fetchModelAtom, modelRegistryInitializedAtom } from './modelRegistry';

export function useInitModelRegistry() {
  const fetchContents = useSetAtom(fetchDownloadableContentsAtom);
  const fetchModel = useSetAtom(fetchModelAtom);
  const setInitialized = useSetAtom(modelRegistryInitializedAtom);

  useEffect(() => {
    const init = async () => {
      try {
        await fetchContents();
      } catch (error) {
        Sentry.captureException(error, {
          tags: {
            source: 'downloadableContents',
          },
        });
      }
      /**
       * TODO: 모델 다운 시점을 로그인 후로 가져갈 지 결정 필요
       *
       * 로그인 전
       * - 유저 행동이 접속 -> 로그인 -> 즉시 매치 시작이라면 첫 매치 전 모델 다운 완료될 확률 높아짐.
       *
       * 로그인 후
       * - 다운 받을 모델이 많아지는 경우 remote config 등을 통해 사용하는 모델만 필터하여 다운받는 등의 최적화 가능
       */
      // entries가 비어있어도 각 모델은 static fallback으로 진행
      await Promise.allSettled(DLC_MODEL_TYPES.map((type) => fetchModel({ modelType: type })));
      setInitialized(true);
    };
    init();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
